<template>
    <eSesjaModal>
        <eSesjaModalHeader @close="$store.commit('setNfcAssigmentModalStatus', false)">
            {{ $t('com.file.contacts.nfc-person-assigments') }}
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <table class="table-bootstrap table-bootstrap-bordered table-bootstrap-hover table-bootstrap-striped nfc-table">
                <thead>
                    <th>#</th>
                    <td>{{ $t('com.nfc-assigment-modal.person') }}</td>
                    <td>{{ $t('com.nfc-assigment-modal.nfc') }}</td>
                    <td></td>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in nfcAssigment" :key="index" style="height: 65px">
                        <td class="align-middle">{{ index + 1 }}</td>
                        <td class="align-middle">
                            <div class="d-flex flex-row gap-2">
                                <img :src="item.avatar" :alt="item.first_name + ' ' + item.last_name" class="avatar"/>
                                <div class="d-flex flex-column">
                                    <span>{{ item.first_name }} {{ item.last_name }}</span>
                                    <span style="font-size: 11px; font-weight: 400;">{{ item.id }}</span>
                                </div>
                            </div>
                        </td>
                        <td class="align-middle" v-if="item.isEdit">
                            <InputComponent v-model="item.nfc" :isError="!isNfcIsValid(item.nfc)" v-tooltip="$t('com.nfc-assigment-modal.valid-nfc-tooltip')" />
                            <CharactersCounter :text="item.nfc" :maxLenght="8" />
                        </td>
                        <td class="align-middle" v-else><span class="d-block" style="width: 220px;">{{ item.nfc }}</span></td>
                        <td class="align-middle ">
                            <div class="d-flex flex-row">
                                <ButtonOnlyWithIcon class="contact-box-custom-button" icon="exit" v-if="item.isEdit" v-tooltip="$t('com.global.close')"  @click="() => item.isEdit = false"  />
                                <ButtonOnlyWithIcon class="contact-box-custom-button" icon="edit" v-else v-tooltip="$t('com.global.edit')" @click="setEditItem(item)" />

                                <ButtonOnlyWithIcon class="contact-box-custom-button" icon="save" v-if="item.isEdit" v-tooltip="$t('com.global.save')" :disabled="!isNfcIsValid(item.nfc)" @click="saveNfcAssigment(item)"/>
                                <ButtonOnlyWithIcon class="contact-box-custom-button" icon="delete" v-else v-tooltip="$t('com.global.delete')" :classModified="true" @click="deleteNfcAssigment(item)" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            &nbsp;
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
import contactService from '../../../../../../services/contact.service';
import ButtonOnlyWithIcon from '../../../../../BasicControls/ButtonOnlyWithIcon.vue';
import InputComponent from '../../../../../BasicControls/InputComponent.vue';
import CharactersCounter from '../../../../../BasicControls/CharactersCounter.vue';
import { isNfcIsValid } from "../../../../../../helpers/utils";

export default {
    name: "NfcAssigmentModal",
    emits: ["refreshGroups"],
    components: {
        ButtonOnlyWithIcon,
        InputComponent,
        CharactersCounter
    },
    computed: {

    },
    data() {
        return {
            nfcAssigment: []
        }
    },
    async mounted() {
        try{
            this.$store.commit("showLoader");
            await this.internalFetchAssigment();
        }
        finally{
            this.$store.commit("hideLoader");
        }
    },
    methods: {
        async internalFetchAssigment(){
            let result = await contactService.getNfcPersonAssigment();

            if(result.status !== 200){
                throw await Promise.reject(result);
            }
            this.nfcAssigment = result.data;
        },
        setEditItem(item){
            this.nfcAssigment = this.nfcAssigment.map((element) => {
                const copy = {...element};
                copy.isEdit = element.id === item.id
                return copy;
            })
        },
        async saveNfcAssigment(item){
            try{
                this.$store.commit("showLoader");
                let response = await contactService.saveNfcPersonAssigment(item.id, item);
                if(response.status != 204){
                    throw await Promise.reject(response)
                }
                await this.internalFetchAssigment();
            }
            catch(e){
                console.log(e);
            }
            finally{
                this.$store.commit("hideLoader");
            }
        },
        async deleteNfcAssigment(item){
            try{
                this.$store.commit("showLoader");
                let response = await contactService.deleteNfcPersonAssigment(item.id);
                if(response.status != 204){
                    throw await Promise.reject(response)
                }
                await this.internalFetchAssigment();
            }
            catch(e){
                console.log(e);
            }
            finally{
                this.$store.commit("hideLoader");
            }
        },
        isNfcIsValid
    }
}
</script>
<style lang="scss">
.nfc-table{
    .avatar{
        width: 35px;
        height: 35px;
        vertical-align: middle;
        border-radius: 50%;
    }
    .contact-box-custom-button{
        margin: 0;
        border-left: 1px solid #bbc2ce;
        border-top: 1px solid #bbc2ce;
        border-bottom: 1px solid #bbc2ce;
        border-right: none;
        border-radius: 0px;
        &:first-of-type{
            border-top-left-radius: 4px !important;
            border-bottom-left-radius: 4px !important;
        }
        &:last-of-type{
            border-right: 1px solid #bbc2ce;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
        }
    }
}
</style>